import React from "react";

// Temporary I•AMovement wordmark echoing the flowing brand logo (final logo supplied later):
// "IAM" as a confident display cap, "ovement" as an elegant hand-feel serif italic.
export function Wordmark({ className = "", size = "text-xl" }) {
  const H = { "text-xl": "h-6", "text-2xl": "h-7", "text-3xl": "h-9" };
  const hcls = H[size] || "h-7";
  return <img src="/media/logo.png" alt="I•AMovement" className={`w-auto ${hcls} ${className}`} draggable="false" />;
}

export default Wordmark;
